import React, { useCallback, useRef, useEffect } from 'react';
import ComingSoon from './ComingSoon';

const Header = ({ onLaunchApp, onShowComingSoon, onNavigate, showComingSoon }) => {
  const isProcessing = useRef(false);
  
  const handleDocsClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (onShowComingSoon) {
      isProcessing.current = true;
      onShowComingSoon();
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }
  }, [onShowComingSoon]);

  const handleHomeClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (showComingSoon && onNavigate) {
      isProcessing.current = true;
      onNavigate('home');
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showComingSoon, onNavigate]);

  const handleFeatureClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (showComingSoon && onNavigate) {
      isProcessing.current = true;
      onNavigate('#feature');
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    } else {
      const element = document.querySelector('#feature');
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [showComingSoon, onNavigate]);

  const handleProcessClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (showComingSoon && onNavigate) {
      isProcessing.current = true;
      onNavigate('#process');
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    } else {
      const element = document.querySelector('#process');
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [showComingSoon, onNavigate]);
  
  const handleLaunchApp = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (onLaunchApp) {
      isProcessing.current = true;
      onLaunchApp();
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }
  }, [onLaunchApp]);


  useEffect(() => {
    // Use event delegation on document to catch clicks on any hamburger_menu
    // This works for both original and cloned (sticky) elements
    const handleDocumentClick = (e) => {
      // Check if click is on hamburger menu or its child
      const hamburger = e.target.closest('.hamburger_menu');
      if (hamburger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Save current scroll position
        const scrollY = window.scrollY;
        
        // Prevent jQuery from handling this
        if (window.jQuery) {
          window.jQuery(hamburger).off('click');
        }
        
        // Get menu elements
        const slideBar = document.querySelector('.slide-bar');
        const bodyOverlay = document.querySelector('.body-overlay');
        const body = document.body;
        
        if (!slideBar || !bodyOverlay) {
          return;
        }
        
        const isOpen = slideBar.classList.contains('show');
        
        if (isOpen) {
          // Close menu
          slideBar.classList.remove('show');
          if (body) body.classList.remove('on-side');
          bodyOverlay.classList.remove('active');
          document.querySelectorAll('.hamburger_menu').forEach(btn => {
            btn.classList.remove('active');
          });
        } else {
          // Open menu
          slideBar.classList.add('show');
          if (body) body.classList.add('on-side');
          bodyOverlay.classList.add('active');
          document.querySelectorAll('.hamburger_menu').forEach(btn => {
            btn.classList.add('active');
          });
          
          // Prevent jQuery from closing it
          if (window.jQuery) {
            window.jQuery(slideBar).off('click');
            window.jQuery(bodyOverlay).off('click');
          }
        }
        
        // Ensure scroll position is maintained
        requestAnimationFrame(() => {
          window.scrollTo(window.scrollX, scrollY);
        });
      }
    };

    // Attach event listener to document with capture phase
    document.addEventListener('click', handleDocumentClick, true);
    
    // Also handle mousedown to prevent default link behavior
    const handleDocumentMouseDown = (e) => {
      const hamburger = e.target.closest('.hamburger_menu');
      if (hamburger) {
        e.preventDefault();
      }
    };
    document.addEventListener('mousedown', handleDocumentMouseDown, true);

    // Remove jQuery handlers aggressively
    const removeJQueryHandlers = () => {
      if (window.jQuery) {
        const hamburgers = document.querySelectorAll('.hamburger_menu');
        hamburgers.forEach((hamburger) => {
          try {
            window.jQuery(hamburger).off('click');
            window.jQuery(hamburger).unbind('click');
            window.jQuery(hamburger).off();
          } catch (e) {
            // Ignore errors
          }
        });
      }
    };

    // Remove immediately
    removeJQueryHandlers();

    // Also remove periodically to catch cloned elements
    const jqueryCleanupInterval = setInterval(() => {
      removeJQueryHandlers();
    }, 300);

    return () => {
      clearInterval(jqueryCleanupInterval);
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('mousedown', handleDocumentMouseDown, true);
    };

    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('mousedown', handleDocumentMouseDown, true);
    };
  }, []);

  return (
    <header className="site-header header-style-two">
      <div className="header__main-wrap stricky">
        <div className="container">
          <div className="header__main ul_li_between">
            <div className="header__logo">
              <a href="/">
                <img src="/logo.svg" alt="Logo" />
              </a>
            </div>
            <div className="main-menu__wrap ul_li navbar navbar-expand-lg">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  {/* <li className="menu-item-has-children active">
                    <a href="/">Home</a>
                    <ul className="submenu">
                      <li><a href="/">Home Chatbot</a></li>
                      <li className="active"><a href="/">Home CRM</a></li>
                      <li><a href="/">Home Copy Writing</a></li>
                    </ul>
                  </li> */}
                  <li><a className="scrollspy-btn" href="/" onClick={handleHomeClick}>Home</a></li>
                  <li><a className="scrollspy-btn" href="#feature" onClick={handleFeatureClick}>Feature</a></li>
                  <li><a className="scrollspy-btn" href="#process" onClick={handleProcessClick}>What is Nova Verse</a></li>
                  <li><a className="scrollspy-btn" href="/" onClick={handleDocsClick}>Docs</a></li>
                </ul>
              </nav>
            </div>
            <div className="d-lg-none">
              <button 
                className="header__bar hamburger_menu" 
                type="button"
                aria-label="Toggle mobile menu"
              >
                <div className="header__bar-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </div>
            <div className="header__button d-none d-lg-block">
            <button
  className="thm-btn thm-btn--gradient style-2"
  onClick={handleLaunchApp}
>
  Launch App
</button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

